// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover-content-uU2a6p{box-sizing:border-box;max-width:400px;overflow:hidden}.popover-card-title-LFKD2d{color:#1c1d24;word-wrap:break-word;margin-bottom:24px;font-size:16px;font-weight:600;line-height:22px}.popover-card-img-dEoJWe{border:1px solid #e5e5e5;border-radius:8px;max-width:360px}.popover-card-img-dEoJWe img{width:100%;height:100%}.popover-card-icon-MsapSI{color:rgba(29,28,35,.35)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover-content": `popover-content-uU2a6p`,
	"popoverContent": `popover-content-uU2a6p`,
	"popover-card-title": `popover-card-title-LFKD2d`,
	"popoverCardTitle": `popover-card-title-LFKD2d`,
	"popover-card-img": `popover-card-img-dEoJWe`,
	"popoverCardImg": `popover-card-img-dEoJWe`,
	"popover-card-icon": `popover-card-icon-MsapSI`,
	"popoverCardIcon": `popover-card-icon-MsapSI`
};
export default ___CSS_LOADER_EXPORT___;
